import { createContext } from 'react';
import { driverObj } from './driverConfig';

export interface TourContextType {
    isTourActive: boolean;
    startTour: () => void;
    endTour: () => void;
    resetTour: () => void;
    hasSeenTour: boolean;
    currentTourStep: number;
    setCurrentTourStep: (step: number) => void;
}

export const TourContext = createContext<TourContextType | undefined>(undefined);

export { driverObj };

export interface TourWindowContext {
    setCurrentTourStep: (step: number) => void;
    toggleMobileMenu?: () => void;
}

declare global {
    interface Window {
        _tourContext: TourWindowContext | undefined;
    }
} 